export const information = [
  {
    title: "一级投资经理",
    tip: "Web3方向",
    duty: [
      "覆盖Web3赛道，进行项目挖掘",
      "推动交易谈判、尽职调查等环节",
      "在Web3领域内与行业内人士建立良好关系，有效挖掘创业者资源和渠道",
      "把握行业热点信息、前沿动态，定期产出行业思考"
    ],
    requirement: [
      "统招本科及以上学历，具有复合背景者优先，英语听说读写精通，可作为工作语言",
      "对Web3和数字货币有强烈兴趣，1-3年PE/VC或FA等相关工作经验，有Web3领域相关工作经验者优先，有创业经验者优先",
      "好奇心、沟通能力、敏感度"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "二级研究员",
    tip: "医药",
    duty: [
      "对行业发展进行前瞻性研究，构建产业图谱和产业数据库，判断行业发展趋势，提供行业研究报告和投资策略",
      "负责行业相关上市公司的研究与分析，对重点公司进行调研、跟踪与预测，并撰写研究报告，为投资人员提供研究支持和投资建议",
      "建立医药行业方向的外部资源网，为公司业务活动提供研究领域内的专业支持"
    ],
    requirement: [
      "1-3年买方或卖方医药行业研究经验，对A股、港股、美股均有关注，生物医药相关专业或相关产业工作经历的优先",
      "对所生物医药行业有独立判断，对行业趋势有敏锐的直觉与观察能力",
      "良好的数据分析能力，有自己的数据分析方法论，能够跟踪数据，深度分析和预测数据发展，可以进行复杂标的的行业分析",
      "具有较强的学习能力和抗压能力，勤于思考、乐于交流、敢于表达，具有良好的沟通协调能力和团队合作精神"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "二级研究员",
    tip: "高端制造&硬科技",
    duty: [
      "对行业发展进行前瞻性研究，构建产业图谱和产业数据库，判断行业发展趋势，提供行业研究报告和投资策略",
      "负责行业相关上市公司的研究与分析，对重点公司进行调研、跟踪与预测，并撰写研究报告，为投资人员提供研究支持和投资建议",
      "建立所在行业方向的外部资源网，为公司业务活动提供研究领域内的专业支持"
    ],
    requirement: [
      "1-3年买方或卖方研究经验，高端制造、硬科技等方向优先，对A股、港股、美股均有关注，行业相关专业的学历背景或相关产业工作经历的优先",
      "对所研究行业有独立判断，对行业趋势有敏锐的直觉与观察能力",
      "良好的数据分析能力，有自己的数据分析方法论，能够跟踪数据，深度分析和预测数据发展，可以进行复杂标的的行业分析",
      "具有较强的学习能力和抗压能力，勤于思考、乐于交流、敢于表达，具有良好的沟通协调能力和团队合作精神"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "二级研究员",
    tip: "大消费",
    duty: [
      "对行业发展进行前瞻性研究，构建产业图谱和产业数据库，判断行业发展趋势，提供行业研究报告和投资策略",
      "负责行业相关上市公司的研究与分析，对重点公司进行调研、跟踪与预测，并撰写研究报告，为投资人员提供研究支持和投资建议",
      "建立所在行业方向的外部资源网，为公司业务活动提供研究领域内的专业支持"
    ],
    requirement: [
      "1-3年买方或卖方大消费行业研究经验，对A股、港股、美股均有关注",
      "对所研究行业有独立判断，对行业趋势有敏锐的直觉与观察能力",
      "良好的数据分析能力，有自己的数据分析方法论，能够跟踪数据，深度分析和预测数据发展，可以进行复杂标的的行业分析",
      "具有较强的学习能力和抗压能力，勤于思考、乐于交流、敢于表达，具有良好的沟通协调能力和团队合作精神"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "法务经理/法务高级经理",
    duty: [
      "投资法务：投资项目法律尽调，交易文件的起草及审核",
      "基金法务：负责基金产品募投管退全流程相关法律事务，提供法律建议",
      "各类基金合规报告的起草和审核",
      "负责对外的法律事务的联络和沟通",
      "其他相关法务工作"
    ],
    requirement: [
      "三年以上私募基金/律所法律相关工作经验，法律专业本科及以上学历，取得法律执业资格或律师资格优先",
      "能独立起草、审核、修改各类合同及相关法律文件",
      "具备双币项目法律经验者优先，熟悉双币基金相关法规和监管要求者优先",
      "开放、沟通、协作、规划、结果导向"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "海外品牌运营",
    duty: [
      "负责知春资本海外渠道搭建，包括运营维护海外官方网站，以及官方Twitter、Discord等海外内容平台",
      "协助行业研究和市场信息调研，参与相应品牌策划执行",
      "定期做运营数据复盘，完成运营方案的迭代"
    ],
    requirement: [
      "国内外知名院校本科或硕士，有海外留学背景",
      "Twitter、Discord等海外内容平台的深度用户，关注科技、互联网新产品，有独立分析能力",
      "对Metaverse有一定的关注基础，且具备极强的好奇心"
    ],
    tel: "请将简历以“职位+姓名”为标题发送至dan.wang@atlascap.com.cn"
  },
  {
    title: "二级市场研究实习生",
    tip: "高端制造、宏观策略方向",
    duty: [
      "聚焦机械、军工、电子、宏观策略等领域研究，深入挖掘产业投资机会",
      "完成项目信息收集和分析的工作，协助或独立完成课题研究以及深度报告撰写 ",
      "提供实习工资及午餐，期间表现优异者有机会获得公司正式offer"
    ],
    requirement: [
      "国内外一流院校全日制本硕，22/23年毕业优先，有相关行业券商实习经验优先",
      "高端制造方向有理工科复合背景优先；宏观策略方向具有较强的数据分析能力，熟悉常用excel公式和python优先",
      "能够保证三个月以上，每周4天以上的实习时间",
      "踏实勤奋、学习能力强，具备较强的数据处理、分析能力，较好的文字表达能力，以及善于沟通"
    ],
    about: [
      "时间：9:00am-6:00pm",
      "福利：a. 提供午餐，b. 实习证明和优秀员工推荐信，c. 表现优秀者有留用机会",
      "邮件：hr@atlascap.com.cn",
      "将邮件主题命名为：“姓名-学校-投递职位-可实习时间”"
    ]
  },
  {
    title: "投资实习生",
    tip: "Web3方向",
    duty: [
      "聚焦区块链行业研究，对产业政策、市场状况进行持续跟踪",
      "协助完成行业信息收集和分析的工作 ",
      "收集新项目并参与沟通和调研，提交高质量的文档报告"
    ],
    requirement: [
      "国内外知名院校本科或硕士学历在读/应届；对区块链和数字货币有强烈兴趣",
      "热爱游戏，对游戏设计/开发/机制/运营有了解加分；对内容创作、社交产品感兴趣或有经验者加分",
      "具备较好的英文翻译基础，经常关注国外媒体报道",
      "心态开放，善于学习，工作主动，具有极强的好奇心和独立思考能力",
      "实习期至少3个月以上"
    ],
    about: [
      "时间：9:00am-6:00pm",
      "福利：a. 提供午餐，b. 实习证明和优秀员工推荐信，c. 表现优秀者有留用机会",
      "邮件：hr@atlascap.com.cn",
      "将邮件主题命名为：“姓名-学校-投递职位-可实习时间”"
    ]
  },
  {
    title: "海外运营实习生",
    duty: [
      "负责知春海外渠道搭建，包括运营维护海外官方网站，以及官方Twitter、Discord等海外内容平台",
      "协助行业研究和市场信息调研，参与相应品牌策划执行 ",
      "定期做运营数据复盘，完成运营方案的迭代"
    ],
    requirement: [
      "国内外知名院校本科或硕士学历/在读，有海外留学背景",
      "Twitter、Discord等海外内容平台的深度用户，关注科技、互联网新产品，有独立分析能力",
      "对Metaverse有一定的关注基础，且具备极强的好奇心",
      "实习期至少3个月以上，每周尽量五天"
    ],
    about: [
      "时间：9:00am-6:00pm",
      "福利：a. 提供午餐，b. 实习证明和优秀员工推荐信，c. 表现优秀者有留用机会",
      "邮件：hr@atlascap.com.cn",
      "将邮件主题命名为：“姓名-学校-投递职位-可实习时间”"
    ]
  }
];



// WEBPACK FOOTER //
// ./src/util/recruit.js